import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _constants$POCUS_ZONE;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import constants from "../../../utils/constants";
var FOURTEEN_POINT_IMAGE_BASE = "/assets/images/scan_assist/fourteen_pointer";
/** Use until 14-point images are added */
var FALLBACK_IMAGE = "".concat(FOURTEEN_POINT_IMAGE_BASE, "/RAS.svg");
var POCUS_ZONES = (_constants$POCUS_ZONE = constants.POCUS_ZONES) !== null && _constants$POCUS_ZONE !== void 0 ? _constants$POCUS_ZONE : ["RLS", "RLI", "RA", "RAS", "RAI", "LA", "LAS", "LAI", "LLS", "LLI", "LPS", "LPI", "RPS", "RPI"];
/**
 * 14 Point Protocol step content by point index (0-13) and phase.
 * Labels use POCUS_ZONES (RAS, RAI, RLS, ...). Add images under public/assets/images/fourteen_point/ when available.
 */
export function getFourteenPointStepContent(t) {
  var entries = {};
  for (var i = 0; i < 14; i++) {
    var _POCUS_ZONES$i;
    var label = (_POCUS_ZONES$i = POCUS_ZONES[i]) !== null && _POCUS_ZONES$i !== void 0 ? _POCUS_ZONES$i : String(i + 1);
    entries[i] = {
      transverse: {
        label: label,
        imageSrc: "".concat(FOURTEEN_POINT_IMAGE_BASE, "/").concat(label, ".svg"),
        instructionLine1: t("capture_3_images", "Capture 3 images"),
        instructionLine2: t("with_probe_in_longitudinal", "with the probe in longitudinal...")
      },
      longitudinal: {
        label: label,
        imageSrc: "".concat(FOURTEEN_POINT_IMAGE_BASE, "/").concat(label, ".svg"),
        instructionLine1: t("capture_3_images", "Capture 3 images"),
        instructionLine2: t("with_probe_in_transverse", "with the probe in transverse...")
      }
    };
  }
  return entries;
}
export function getFourteenPointPointLabel(pointIndex) {
  var _POCUS_ZONES$pointInd;
  return (_POCUS_ZONES$pointInd = POCUS_ZONES[pointIndex]) !== null && _POCUS_ZONES$pointInd !== void 0 ? _POCUS_ZONES$pointInd : String(pointIndex + 1);
}

/** Slide progress per point: 4 (2-2) or 6 (3-3). Default 4 for all. */
var FOURTEEN_POINT_SLIDES = {
  0: 6,
  1: 6,
  2: 6,
  3: 6,
  4: 6,
  5: 6,
  6: 6,
  7: 6,
  8: 6,
  9: 6,
  10: 6,
  11: 6,
  12: 6,
  13: 6
};
function slidesConfigFromTotal(total) {
  var half = Math.floor(total / 2);
  return {
    total: total,
    filledByPhase: {
      transverse: 0,
      longitudinal: half,
      submit: total
    }
  };
}
export function getFourteenPointSlidesConfig(pointIndex) {
  var _FOURTEEN_POINT_SLIDE;
  return slidesConfigFromTotal((_FOURTEEN_POINT_SLIDE = FOURTEEN_POINT_SLIDES[pointIndex]) !== null && _FOURTEEN_POINT_SLIDE !== void 0 ? _FOURTEEN_POINT_SLIDE : 4);
}

/**
 * Get step content for a 14-point index and phase. Uses longitudinal content for "submit" phase.
 */
export function getFourteenPointContentForPointPhase(pointIndex, phase, t) {
  var _contentMap$pointInde;
  var contentMap = getFourteenPointStepContent(t);
  var pointContent = (_contentMap$pointInde = contentMap[pointIndex]) !== null && _contentMap$pointInde !== void 0 ? _contentMap$pointInde : contentMap[0];
  var effectivePhase = phase === "submit" ? "longitudinal" : phase;
  var content = pointContent[effectivePhase];
  return _objectSpread(_objectSpread({}, content), {}, {
    imageSrc: content.imageSrc || FALLBACK_IMAGE
  });
}